export default {
  init() {
    // JavaScript to be fired on the home page
    $.fancybox.defaults.image.preload = 0;
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    // $('.ftx_photography__item .image').fancybox({
    //   // image: {
    //   //   preload: false,
    //   // },
    //   // preload: false,
    //   // arrows: true,
    // });

    if ($(window).width() < 992) {
      $('.toggle-switch .category-title').on('click touch', function () {
        var cat = $(this).parent().data('target-category');

        $('.ftx_photography')
          .find('[data-category="' + cat + '"]')
          .slideToggle();

        $(this).parent().toggleClass('open');
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/archivePhotography.js